import {
  faBullseye,
  faGraduationCap,
  faHandsHelping,
  faPlug,
  faShieldAlt,
  faUserCheck,
} from "@fortawesome/free-solid-svg-icons";
import Footer from "../../../components/footer/Footer";
import Imagewheel from "../../../components/imagewheel/Imagewheel";
import Newsletter from "../../../components/newsletter/Newsletter";
import Walkthrough from "../../../components/walkthrough/Walkthrough";
import {
  FlexFirstContainer,
  FlexFirstImage,
  FlexFirstIntroTitle,
  FlexFirstLine,
  FlexFirstText,
  FlexFirstTextContainer,
  FlexFirstTitle,
  FlexPageContainer,
  FlexSecondCard,
  FlexSecondCardsContainer,
  FlexSecondCardIcon,
  FlexSecondCardText,
  FlexSecondCardTitle,
  FlexSecondIntroTitle,
  FlexSecondTextContainer,
  FlexSecondTitle,
  FlexSecondContainer,
  FlexThirdWalkthrough,
} from "./FlexStyles";

function Flex() {
  const images = ["/assets/4.jpg", "/assets/5.jpg", "/assets/8.jpg"];

  return (
    <FlexPageContainer>
      {/* Commissioners - Flex: Imagewheel */}
      <Imagewheel images={images} isFlex={true} />

      {/* Commissioners - Flex: First Section */}
      <FlexFirstContainer>
        <FlexFirstImage src="/assets/9.jpg" alt="Smart Personeel" />
        <FlexFirstTextContainer>
          <FlexFirstIntroTitle>
            Smart Flex - PNIL: Personeel niet in loondienst
          </FlexFirstIntroTitle>
          <FlexFirstTitle>Uit zorg ontstaan, met zorg gegroeid</FlexFirstTitle>
          <FlexFirstText>
            Bij Smart-Personeel zetten we PNIL volledig DBA-proof in, zodat jouw
            organisatie voldoet aan alle wet- en regelgeving. Of je nu opzoek
            bent naar de flexibiliteit van een uitzendkracht, projectmatig voor
            een periode personeel nodig hebt in de detachering of flex diensten
            wilt laten invullen door een ZZP’er. Onze overeenkomsten worden met
            zorg samengesteld en zijn altijd up-to-date. Dit biedt zekerheid
            voor zowel de opdrachtgever als de werknemer die jouw organisatie
            komt ondersteunen.
          </FlexFirstText>
          <FlexFirstText>
            Onze professionals hebben ervaring en zijn direct inzetbaar. We
            bieden een breed scala aan zorgspecialisten, van begeleiders en
            verpleegkundigen tot planners en managers. Wat jouw organisatie ook
            nodig heeft, wij zorgen voor de juiste ondersteuning. Samen
            organiseren we eenmaal de processen van contractbeheer tot
            administratieve afhandeling, zodat jouw organisatie zich kan richten
            op wat echt belangrijk is: het leveren van zorg.
          </FlexFirstText>
          <FlexFirstLine />
        </FlexFirstTextContainer>
      </FlexFirstContainer>

      {/* Commissioners - Flex: Second Section */}
      <FlexSecondContainer>
        <FlexSecondTextContainer>
          <FlexSecondIntroTitle>
            Flexibel met behoud van kwaliteit
          </FlexSecondIntroTitle>
          <FlexSecondTitle>Alsof je samenwerkt met een collega</FlexSecondTitle>
        </FlexSecondTextContainer>
        <FlexSecondCardsContainer>
          <FlexSecondCard>
            <FlexSecondCardIcon icon={faBullseye} />
            <FlexSecondCardTitle>Voor elke uitdaging</FlexSecondCardTitle>
            <FlexSecondCardText>
              Of het nu gaat om een spoeddienst of langdurige inzet, wij zorgen
              voor de juiste professional.
            </FlexSecondCardText>
          </FlexSecondCard>

          <FlexSecondCard>
            <FlexSecondCardIcon icon={faUserCheck} />
            <FlexSecondCardTitle>Altijd de juiste match</FlexSecondCardTitle>
            <FlexSecondCardText>
              Van begeleiders tot aan managers, wij hebben de juiste match voor
              elke behoefte.
            </FlexSecondCardText>
          </FlexSecondCard>

          <FlexSecondCard>
            <FlexSecondCardIcon icon={faPlug} />
            <FlexSecondCardTitle>Slimme koppeling</FlexSecondCardTitle>
            <FlexSecondCardText>
              Koppel je planningssysteem eenvoudig via onze API en zet direct
              diensten uit.
            </FlexSecondCardText>
          </FlexSecondCard>

          <FlexSecondCard>
            <FlexSecondCardIcon icon={faShieldAlt} />
            <FlexSecondCardTitle>
              Flexibele schil zonder risico's
            </FlexSecondCardTitle>
            <FlexSecondCardText>
              Direct inzetbare zorgprofessionals, precies wanneer jouw
              organisatie extra ondersteuning nodig heeft.
            </FlexSecondCardText>
          </FlexSecondCard>

          <FlexSecondCard>
            <FlexSecondCardIcon icon={faHandsHelping} />
            <FlexSecondCardTitle>Altijd betrokken</FlexSecondCardTitle>
            <FlexSecondCardText>
              We overleggen regelmatig om de zorg samen te verbeteren. Jouw
              processen, onze focus.
            </FlexSecondCardText>
          </FlexSecondCard>

          <FlexSecondCard>
            <FlexSecondCardIcon icon={faGraduationCap} />
            <FlexSecondCardTitle>Deskunding</FlexSecondCardTitle>
            <FlexSecondCardText>
              Alle zorgprofessionals beschikken over een geldig diploma, VOG en
              minimaal 3 jaar relevante werkervaring.
            </FlexSecondCardText>
          </FlexSecondCard>
        </FlexSecondCardsContainer>
      </FlexSecondContainer>

      {/* Commissioners - Flex: Third Section */}
      <FlexThirdWalkthrough>
        <Walkthrough page="flex" />
      </FlexThirdWalkthrough>

      {/* Commissioners - Flex: Newsletter */}
      <Newsletter />

      {/* Commissioners - Flex: Footer */}
      <Footer />
    </FlexPageContainer>
  );
}

export default Flex;
